import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';

const apiStates = restApiStates(['orders', 'invoice-messages'], 'message');

const instantStates = [];
const storage = {};
const listValues = ['messages'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
